import { Directive, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'projects/environments/environment';
import { AppEnvironment } from '@solvace/config/model/environment.model';

class EnvironmentContext {
  public $implicit: AppEnvironment = null!;
}

@Directive({
  // eslint-disable-next-line
  selector: '[environment]',
})
export class EnvironmentDirective {
  env = environment;

  #viewContainer = inject(ViewContainerRef);
  #templateRef = inject(TemplateRef<EnvironmentContext>);

  environment = input<string>();

  static ngTemplateGuard_environment: 'binding';

  constructor() {
    this.#viewContainer.createEmbeddedView(this.#templateRef!, {
      $implicit: this.env,
    });
  }

  // eslint-disable-next-line
  static ngTemplateContextGuard(dir: EnvironmentDirective, ctx: EnvironmentContext): ctx is EnvironmentContext {
    return true;
  }
}
